import { isDefined, numberOrZero } from "@/utils/utils";
import { Button, Popover } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatLocaleNumber } from "../../../../../../common/utils/formatUtils";
import { tInterval } from "../../../../../../common/utils/translationUtils";
import { UUID } from "../../../../../../typings/global";
import { DashboardGoal } from "../../../../types";
import { getPercentage } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";
import { AddGoalModal } from "../modals/AddGoalModal";
import { isCreatedGoal } from "../utils";

type Props = {
  goal?: DashboardGoal;
  year: number;
  agentId: UUID;
};

export const TipperDirectTraineesWrapper = ({ goal, year, agentId }: Props) => {
  const { t } = useTranslation();

  const [isOpenSetGoalModal, setIsOpenSetGoalModal] = useState(false);

  const hasTarget = isDefined(goal?.targetValue);
  const actualValue = numberOrZero(goal?.actualValue);
  const targetValue = numberOrZero(goal?.targetValue);

  const currentPercentage = isCreatedGoal(goal) ? getPercentage(actualValue, targetValue) : 0;

  return (
    <>
      <GoalCard
        agentId={agentId}
        year={year}
        goal={goal}
        percentage={currentPercentage}
        label={
          hasTarget ? (
            <Popover content={t("dashboard.goals.helpers.directTraineesGoalHint")}>
              {t("dashboard.enums.dashboardGoalType.TIPPER_DIRECT_TRAINEES")}
            </Popover>
          ) : (
            <Button onClick={() => setIsOpenSetGoalModal(true)}>{t("dashboard.goals.actions.setTarget")}</Button>
          )
        }
        hasTarget={hasTarget}
        targetLabel={
          hasTarget ? undefined : (
            <div style={{ color: "white" }}>
              <div>{formatLocaleNumber(actualValue)}</div>
              <span style={{ fontSize: 16 }}>
                {tInterval("dashboard.goals.helpers.trainees_interval", actualValue)}
              </span>
            </div>
          )
        }
        tooltipTitle={
          hasTarget ? (
            <p>
              {actualValue} {tInterval("dashboard.goals.helpers.trainees_interval", actualValue)}{" "}
              {t("dashboard.goals.helpers.from")} {targetValue}
            </p>
          ) : undefined
        }
      />

      {goal && agentId ? (
        <AddGoalModal
          isOpen={isOpenSetGoalModal}
          onCancel={() => setIsOpenSetGoalModal(false)}
          goalType={goal.type}
          year={year}
          agentId={agentId}
        />
      ) : undefined}
    </>
  );
};
